import { useCallback } from 'react'
import { ModalType } from '$/types'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import {
  closeModal,
  openSystemScopeModal,
  openLocalFilterModal,
  openWisDetailsModal
} from 'app/entities/store/modalsSlice'
import { selectModals } from 'app/entities/store/modalsSelectors'
import { WisDetailsModal } from 'common/components/WISDetailsModal'
import SystemScopeModalWrapper from 'app/layout/Navbar/Filters/FilterModal/SystemScopeModalWrapper'
import LocalFilterModalWrapper from 'features/RiskManagement/Components/LocalFilter/Modal/LocalFilterModalWrapper'

const Modals = () => {
  const modals = useAppSelector(selectModals)
  const dispatch = useAppDispatch()

  const modalTypesToWrappers: Record<string, React.FC<ModalType>> = {
    [openLocalFilterModal.type]: LocalFilterModalWrapper,
    [openSystemScopeModal.type]: SystemScopeModalWrapper,
    [openWisDetailsModal.type]: WisDetailsModal
  }

  const onClose = useCallback(() => {
    dispatch(closeModal())
  }, [dispatch])

  return (
    modals.length > 0 &&
    modals.map((modalType) => {
      const ModalComponent = modalTypesToWrappers[modalType.id] ?? null

      if (!ModalComponent) {
        return
      }

      return <ModalComponent key={modalType.id} onClose={onClose} />
    })
  )
}

export default Modals
